module.exports = __webpack_public_path__ + "img/img2.3c76e63e.jpg";